import { useCallback, useEffect, useRef, useState } from 'react';

import {
  containsActivationVariable,
  isActivationFamily,
} from '../utils/activationLink';

const EVALUATION_DELAY_MS = 150;

const useActivationLinkWarning = (family) => {
  const [hasVariable, setHasVariable] = useState(false);
  const [hasContent, setHasContent] = useState(false);
  const timeoutRef = useRef(null);

  const evaluateContent = useCallback((content) => {
    setHasContent(true);
    const present = containsActivationVariable(content);
    setHasVariable((prev) => (prev === present ? prev : present));
  }, []);

  const handleEditorChange = useCallback(
    (json) => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(
        () => evaluateContent(json),
        EVALUATION_DELAY_MS
      );
    },
    [evaluateContent]
  );

  useEffect(
    () => () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    },
    []
  );

  const showWarning =
    isActivationFamily(family) && hasContent && !hasVariable;

  return { showWarning, handleEditorChange, evaluateContent };
};

export default useActivationLinkWarning;
